import { siteConfig } from '../config/siteConfig';

const post = async (path, payload) => {
  let response;
  try {
    response = await fetch(siteConfig.apiBaseUrl + path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
  } catch {
    const error = new Error(
      'Sunucuya ulaşılamadı. Bağlantınızı kontrol edip tekrar deneyin.'
    );
    error.code = 'NETWORK_ERROR';
    error.fieldErrors = {};
    throw error;
  }

  const data = await response.json().catch(() => ({
    success: false,
    message: 'Sunucudan geçerli bir yanıt alınamadı.',
    fieldErrors: {},
  }));

  if (!response.ok || !data.success) {
    const error = new Error(data.message || 'İşlem tamamlanamadı.');
    error.code = data.code;
    error.fieldErrors = data.fieldErrors || {};
    throw error;
  }

  return data;
};

export const sendContactMessage = (payload) =>
  post('/support/contact-message', payload);

export const requestAccountDeletionCode = (payload) =>
  post('/support/delete-account/code', payload);

export const sendAccountDeletionRequest = (payload) =>
  post('/support/delete-account-request', payload);
